export default {
    name: "mansonry-posts",
    template: '#vue-mansonry-posts',

    data() {
        return {
            isLoaded: false,
        }
    },

    props: {
        posts: Array,
    },

    mounted() {
        this.isLoaded = true;
    },
}